import React from "react";
import {Redirect} from "react-router-dom";
import PropTypes from "prop-types";
// React component for creating dynamic tables
import ReactTable from "react-table";

import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import People from "@material-ui/icons/Contacts";
import Refresh from "@material-ui/icons/Refresh";

/*
 * Import Assignment from "@material-ui/icons/Assignment";
 * core components
 */
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Pagination from "customs/components/Pagination";

import {connect} from "react-redux";
import AuthService from "customs/auth/AuthService";
import helpers from "customs/helpers/helpers";
import {doLogout} from "../../store/actions/authActions";

import axios from "axios/axios";

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import axiosHelper from "axios/axiosHelper";
import TextField from "@material-ui/core/TextField";
import {InputAdornment} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import Button from "components/CustomButtons/Button.jsx";
import Assignment from "@material-ui/icons/Assignment";

import moment from "moment";
import "moment-timezone";

import AccessControl from "customs/components/AccessControl";

class Merchants extends React.Component {

    constructor (props) {

        super(props);
        this.state = {
            "pages": 0
        };
        this.fetchData = this.fetchData.bind(this);
        this.loadApplication = this.loadApplication.bind(this);
        this.parentComponent = this.parentComponent.bind(this);
        window.parentComponent = this.parentComponent;

    }

    parentComponent(action, params) {
        
    }

    fetchData (state, instance) {
        this.setState({"loading": true});
    }
    
    componentDidMount () {
        this._ismounted = true;
        window.onunload = function() {
            if (this.viewApplicationWindow !== null && !this.viewApplicationWindow.closed) {
                this.viewApplicationWindow.close();
                this.viewApplicationWindow = null;
            }
        }.bind(this);
    }

    componentWillUnmount() {
        if (this.viewApplicationWindow !== null && !this.viewApplicationWindow.closed) {
            this.viewApplicationWindow.close();
            this.viewApplicationWindow = null;
        }
        this.isUnmounted = true;
    }

    processErrorAxios (error) {
        axiosHelper.processError(
            this.isUnmounted,
            null,
            error,
            (state) => {
                this.setState(state);
            },
            null,
            () => {
                this.props.doLogout({...this.props});
            }
        );
    }

  refreshMerchantsTable () {
      this.refReactMerchantsTable.fireFetchData();
  }

  CustomTableFilter = ({filter, onChange}) => (<form>
          <TextField
              type="search"
              className="w-100"
              value={filter ? filter.value : ""}
              onChange={(event) => onChange(event.target.value)}
              InputProps={{
                  startAdornment: 
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            
              }}
          />
       </form>)
    ;

    MerchantsTableColumns = [
        {
            "Header": "ID",
            "accessor": "id",
            "width": 70,
            "Filter": this.CustomTableFilter
        },
        {
            "Header": "Name",
            "accessor": "name",
            "Filter": this.CustomTableFilter
        },
        {
            "Header": "Email",
            "accessor": "email",
            "Filter": this.CustomTableFilter
        },
        // {
        //     "Header": "Phone",
        //     "accessor": "phone",
        //     "Filter": this.CustomTableFilter
        // },
        {
            "Header": "Company",
            "accessor": "company",
            "Filter": this.CustomTableFilter
        },
        {
            "Header": "Position",
            "accessor": "position",
            "filterable": false,
            "sortable": false,
        },
        {
            "Header": "Address",
            "accessor": "address",
            "filterable": false,
            "sortable": false,
        },
        {
            "Header": "Verified",
            "accessor": "email_verified",
            "filterable": false,
            // "headerStyle": {textAlign: 'left'}
        },
        {
            "Header": "Created",
            "accessor": "created_at",
            "filterable": false
        },
        {
            "Header": "Application Status",
            "accessor": "status",
            "width": 170,
            "filterable": false,
            "sortable": false,
        },
        {
            "Header": "Actions",
            "accessor": "actions",
            "sortable": false,
            "filterable": false,
            "width": 80
        }
    ];

  processMerchantsData (res) {
      if (this.isUnmounted) {
          return;
      }
      const {merchant_selected} = this.state;
      this.setState({"merchant_selected": null});
      this.setState({
          "tableData": res.data.data.map((prop, key) => {
              if (
                merchant_selected &&
                merchant_selected.id &&
                merchant_selected.id === prop.id
              ) {
                  this.setState({"merchant_selected": prop});
              }
              return this.setMerchantDetails(
                  prop,
                  key
              );

          }),
          "pages": res.data.last_page,
          "items_data": res.data.from && res.data.to && res.data.total
            ? `${res.data.from} - ${res.data.to} of ${res.data.total}`
            : "",
          "loading": false,
          "MerchantsSources": res.data.sources
      });
  }

    loadApplication(application_id) {
        helpers.showLoading();
        axios(this.props)
            .get("/applications/" + application_id)
            .then((res) => {
                helpers.hideLoading();
                
                if (this.isUnmounted) {
                    return;
                }
                this.loadViewApplication(res)
            })
            .catch((error) => {});
    }

    viewApplicationWindow = null;
    loadViewApplication(results) {
        let approval = JSON.parse(JSON.stringify(results.data.application));
        let status = results.data.application.status;
        approval.name = results.data.application.merchant_user.first_name + ' ' + results.data.application.merchant_user.last_name;
        approval.company = results.data.application.merchant_user.company;
        approval.email = results.data.application.merchant_user.email;
        approval.created_at = moment.utc(results.data.created_at).format(helpers.date_format() + ' HH:mm:ss')
        approval.status = <span style={{"color": helpers.application_status_colors()[status] }}>{helpers.fixStatusLabel(status)}</span>;
        approval.page_notes = results.data.application.page_notes;
        approval.details = results.data.application.details;
        let app_state = {
            "applicationView": true, //!this.state.appViewClosed,
            "appViewClosed": false,
            "client_files": results.data.client_files,
            "mccs": results.data.mccs,
            "business_types": results.data.business_types,
            "registry_entries": results.data.registry_entries,
            "application_history": results.data.status_history,
            "available_fields": results.data.available_fields,
            "selected_client_id": approval.merchant_user.client.id,
            "selected_client_script_id": results.data.selected_client_script_id,
            "selected_client_script_step_id": results.data.selected_client_script_step_id,
            "selected_approval": approval,
            "page_notes": approval.page_notes,
            "selected_application_id": approval.id,
            "high_risk_mccs": results.data.high_risk_mccs,
            "nexxtap_supported_android_versions": results.data.nexxtap_supported_android_versions,
            "nexxtap_supported_android_min_version": results.data.nexxtap_supported_android_min_version,
            "application_status": status,
            "approval_message": results.data.messages,
            "application_details": [approval.company, approval.abn.length > 0 ? '(ABN: ' + helpers.abnFormat(approval.abn) + ')' : ''].join(' '),
            "onboarding_name": results.data.onboarding_name,
            "updateApplication": this.state.updateApplication,
            "canApprove": this.state.canApprove,
            "merchant_user": {
                "id": approval.merchant_user.id ? approval.merchant_user.id : "",
                "first_name": approval.merchant_user.first_name ? approval.merchant_user.first_name : "",
                "middle_name": approval.merchant_user.middle_name ? approval.merchant_user.middle_name : "",
                "last_name": approval.merchant_user.last_name ? approval.merchant_user.last_name : "",
                "date_of_birth": approval.merchant_user.date_of_birth ? approval.merchant_user.date_of_birth : "",
                "position": approval.merchant_user.position ? approval.merchant_user.position : "",
                "phone": approval.merchant_user.phone ? approval.merchant_user.phone : "",
                "email": approval.merchant_user.email ? approval.merchant_user.email : "",
                "company": approval.merchant_user.company ? approval.merchant_user.company : "",
                "address": approval.merchant_user.address ? approval.merchant_user.address : "",
                "city": approval.merchant_user.city ? approval.merchant_user.city : "",
                "state": approval.merchant_user.state ? approval.merchant_user.state : "",
                "postcode": approval.merchant_user.postcode ? approval.merchant_user.postcode : ""
            }
        };
        // this.setState(app_state);
        helpers.hideLoading();

        helpers.cleanLocalStorage('admin_app_');
        localStorage.setItem('admin_app_' + approval.id + '_state', JSON.stringify(app_state));
        let path = '/admin/merchant/application/' + approval.id;
        if (this.viewApplicationWindow === null || this.viewApplicationWindow.closed) {
            localStorage.setItem('admin_app_' + approval.id + '_props', JSON.stringify(this.props));
            try {
                this.viewApplicationWindow = window.open(path, '');
            } catch(e) {
                console.log(e);
            } finally {
            }
        } else {
            if (!this.viewApplicationWindow.location.href.endsWith(path)) {
                localStorage.setItem('admin_app_' + approval.id + '_props', JSON.stringify(this.props));
                this.viewApplicationWindow.location.href = path;
            }
        }
        if (!this.state.dont_focus_child && this.viewApplicationWindow !== null && !this.viewApplicationWindow.closed) {
            this.viewApplicationWindow.focus();
        }
        this.setState({"dont_focus_child": false});

        try {
            if (app_state.applicationView) this.viewApplicationWindow.updateComponent();
        } catch(e) {}
    }

    setMerchantDetails (prop, key) {
        prop.address = (prop.address ? prop.address : "") + (prop.city ? ", " + prop.city : "") + (prop.state ? ", " + prop.state : "") + (prop.postcode ? ", " + prop.postcode : "");
        let progress = Math.abs(prop.application_progress);
        prop.status = prop.application_status === null && prop.application_progress !== null
            ? (parseInt(prop.application_progress) < 0 ? "N/A" : <span>
                {progress.toString() + "% completed"}
                <span style={{color: "blue"}}>{progress > 0 && progress < 100 && prop.field && prop.field.page && prop.field.page.length > 0 ? helpers.addLineBreaks('<br>' + prop.field.page + ' >') : ''}</span>
                <span style={{color: "purple"}}>{progress > 0 && progress < 100 && prop.field && prop.field.field && prop.field.field.length > 0 ? helpers.addLineBreaks(prop.field.field) : ''}</span>
            </span>)
            : <span style={{"color": helpers.application_status_colors()[prop.application_status] }}>{helpers.fixStatusLabel(prop.application_status)}</span>;
        prop.email_verified = prop.email_verified_at === null ? "No" : "Yes";
        prop.actions = prop.application_id !== null
            ? <div key={key}>
                <Button
                    title={'Details'}
                    className="edit"
                    color="info"
                    justIcon
                    onClick={(event) => {
                        this.loadApplication(prop.application_id);
                    }}
                    round
                    simple
                >
                    <Assignment />
                </Button>
            </div>
            : <div key={key}>&nbsp;</div>;
        return prop;
    }

  getMerchantsData (page, pageSize, sorted, filtered, handleRetrievedData) {
      const url = "/merchants",
          postObject = {
              "page": page + 1,
              "per_page": pageSize,
              "sort": sorted,
              "filter": filtered
          };

      return axios(this.props)
        .post(
              url,
              postObject
          )
          .then((response) => handleRetrievedData(response))
          .catch((error) => this.processErrorAxios(
              error,
              null
          ));
  }

  render () {
      const authService = new AuthService(
          this.state,
          this.props
      );
        if (!AccessControl.checkRoutePermissions("/merchants", this.props.auth)) {
            return <Redirect to="/admin/dashboard" />;
        }
      if (!authService.getToken()) {
          return <Redirect to="/auth/login" />;
      }

      if (authService.isPasswordExpired()) {
          return <Redirect to="/admin/changepassword" />;
      }
      const {classes} = this.props,
          {tableData, pages, loading} = this.state;
      return (
          <div>
              <GridContainer>
                  <GridItem xs={12}>
                      <Card>
                          <CardHeader
                              color="success"
                              icon
                          >
                              <CardIcon color="success">
                                  <People />
                              </CardIcon>
                              <h4 className={classes.cardIconTitle}>
                                Merchants
                              </h4>
                              <CardIcon
                                  title={'Refresh merchants table'}
                                  className="float-button"
                                  color="warning"
                                  onClick={() => this.refreshMerchantsTable()}
                              >
                                  <Refresh />
                              </CardIcon>
                          </CardHeader>
                          <CardBody>
                              <ReactTable
                                  className="-striped -highlight"
                                  columns={this.MerchantsTableColumns}
                                  data={tableData}
                                  defaultSorted={[{ id: 'id', desc: true }]}
                                  defaultFilterMethod={(filter, row) => String(row[filter.id]) === filter.value}
                                  defaultPageSize={10}
                                  filterable
                                  itemsCountText={this.state.items_data}
                                  loading={loading}
                                  manual
                                  onFetchData={(state, instance) => {
                                      this.setState({"loading": true});
                                      this.getMerchantsData(
                                          state.page,
                                          state.pageSize,
                                          state.sorted,
                                          state.filtered,
                                          (res) => this.processMerchantsData(res)
                                      );
                                  }}
                                  pages={pages}
                                  PaginationComponent={Pagination}
                                  ref={(refReactMerchantsTable) => {
                                      this.refReactMerchantsTable = refReactMerchantsTable;
                                  }}
                                  showPageSizeOptions
                                  showPaginationBottom
                                  showPaginationTop={false}
                              />
                          </CardBody>
                      </Card>
                  </GridItem>
              </GridContainer>
          </div>
      );
  }
}

Merchants.propTypes = {
    "classes": PropTypes.object
};

const mapStateToProps = (state, props) => ({
        "auth": state.auth.data
    }),

    mapDispatchToProps = (dispatch) => ({
        "doLogout": (props) => dispatch(doLogout(props))
    });

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(extendedFormsStyle)(Merchants));
